export default "__VITE_ASSET__BwX21zy4__"